import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import ReactFontFace from 'react-font-face';

// Custom font for login page
import chevinFont from '../../fonts/chevin_light.ttf';

import * as types from 'misc/types';
import { getText, trackGA } from 'misc/helpers';
import Background from 'images/login_bg.jpg';
import CookiePopup from '../shared/CookiePopup';

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            personnr: '',
            mouseOverLoginButton: false
        };
    }

    render = () => {
        const { sessions, status_check } = this.props;

        // Background image
        const bgStyle = {
            backgroundImage: 'url(' + Background + ')'
        };

        // Sub header with custom font
        const subHeaderStyle = {
            chevinFont: {
                fontFamily: 'Chevin'
            }
        };

        return (
            <div className="wrapper">
                <div className={'login-page' + (sessions.isLoading ? ' animation-blur' : '')} style={bgStyle} />
                <div className="start-content">
                    {status_check.data && (
                        <React.Fragment>
                            {status_check.data.running ? (
                                <React.Fragment>
                                    <div className="login-logo">
                                        <img src="assets/images/digimail_logo_white.svg" alt="Digimail" />
                                    </div>
                                    <h1 style={subHeaderStyle.chevinFont}>{getText('_1_1_TextHeader', 'Framtidens post')}</h1>
                                    {!sessions.isLoading && (
                                        <div className="login-form-container">
                                            <div className="info-text">
                                                {getText(
                                                    '_1_1_text_login',
                                                    'Digimail - Din digitala brevlåda. Få din post digitalt! Snabbt, smidigt, säkert och gratis!'
                                                )}
                                                <br />
                                            </div>

                                            <div className="login-form">
                                                <form onSubmit={e => this._onSubmit(e)}>
                                                    <input
                                                        className="input-inline"
                                                        type="text"
                                                        maxLength="10"
                                                        placeholder={getText('_1_1_Textpersonalnumber', 'Personnummer (10 siffror)')}
                                                        min="0"
                                                        onChange={e => this._inputChange(e)}
                                                    />

                                                    <button
                                                        className="button-yellow button-login button-bankid"
                                                        disabled
                                                        ref="loginButton"
                                                        type="submit"
                                                    >
                                                        <span>{getText('_1_0_TextLogin', 'Logga in')}</span>
                                                    </button>
                                                </form>
                                            </div>
                                            <footer className="login-footer">
                                                {getText('registerLinkFeatureToggle') && (
                                                    <p>
                                                      <span>{getText('Missing', 'Inget konto?')}</span>
                                                      <Link to="/register_info" className="register-link">
                                                          {getText('_1_1_ButtonGet', 'Skaffa Digimail')}
                                                      </Link>
                                                    </p>
                                                )}
                                                <p>
                                                    <a href="https://digimail.zendesk.com" rel="noopener noreferrer" target="_blank">
                                                        {getText('_1_1_faq_login', 'Frågor och funderingar, klicka här')}
                                                    </a>
                                                </p>
                                            </footer>
                                        </div>
                                    )}
                                </React.Fragment>
                            ) : (
                                <div className="server-status-message">
                                    <img src="assets/images/popup/ico_error.svg" alt="" />
                                    <h2>{getText('_0_0_Titel_disruption', 'Vi har just nu en driftstörning')}</h2>
                                    <p>{getText('_0_0_Text_disruption', 'Vänligen prova igen om en stund')}</p>
                                </div>
                            )}
                        </React.Fragment>
                    )}
                </div>
                {!localStorage.hide_cookie_popup && <CookiePopup />}
            </div>
        );
    };

    mouseOver(mouseOver) {
        this.setState({
            mouseOver: mouseOver
        });
    }

    _inputChange(event) {
        this.setState({ personnr: event.target.value });

        event.target.value = event.target.value.replace(/[^\d.]/g, '');

        if (event.target.value) {
            this.refs.loginButton.disabled = false;
        } else {
            this.refs.loginButton.disabled = true;
        }
    }

    _onSubmit(event) {
        event.preventDefault();

        const { dispatch } = this.props;

        // Start bank id
        dispatch({
            type: types.SAGA_LOGIN.REQUEST,
            personnr: this.state.personnr
        });
    }

    componentDidMount() {
        // Get envelopes
        const { dispatch } = this.props;
        dispatch({ type: types.SAGA_STATUS_CHECK.REQUEST });

        trackGA('1.0 Logga in/Skaffa');
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        sessions: state.sessions,
        status_check: state.status_check
    };
};

// Config for custom fonts
let fontConfig = {
    file: [
        {
            fontFamily: 'Chevin',
            fontWeight: 'normal',
            file: chevinFont,
            fontType: 'truetype'
        }
    ]
};

Login = connect(mapStateToProps)(Login);

export default ReactFontFace(Login, fontConfig);



// WEBPACK FOOTER //
// ./src/components/views/Login.js